import {
  MaterialUICore,
  axiomTokens,
  DialogHeader as DSDialogHeader,
  DialogContent as DSDialogContent,
} from '@iclinic/design-system';

const { styled } = MaterialUICore;
const { spacing } = axiomTokens;

export const DialogHeader = styled(DSDialogHeader)({
  padding: `${spacing[4]} ${spacing[4]}`,
});

export const DialogContent = styled(DSDialogContent)({
  paddingTop: 8,
  paddingBottom: 8,
});
